import { REAUTH_REQUIRED_PARAM } from '@lib/auth/constants/reauth-required-param';
import { REDIRECTED_FROM_PARAM } from '@lib/auth/constants/redirected-from-param';
import { AUTH_ROUTES } from '@lib/constants/apis';

interface SignInRedirectOptions {
  reauthRequired?: boolean;
}

/**
 * Builds the sign-in URL that returns the user to `returnPath` after auth,
 * using the `redirectedFrom` param the auth middleware already understands.
 * `reauthRequired` marks a lapsed-session recovery so the login page renders
 * the form instead of bouncing a still-"signed-in" client back into a loop.
 */
export function buildSignInRedirect(
  returnPath: string,
  { reauthRequired = false }: SignInRedirectOptions = {}
): string {
  const url = `${AUTH_ROUTES.LOGIN}?${REDIRECTED_FROM_PARAM}=${encodeURIComponent(
    returnPath
  )}`;
  return reauthRequired ? `${url}&${REAUTH_REQUIRED_PARAM}=1` : url;
}
